import React from 'react';

const LoginFooter: React.FC = () => {
  return (
    <footer className="absolute bottom-4 left-0 right-0 text-center">
      <div className="text-xs text-westfalen-secondary space-y-1">
        <p>© 2025 Westfalen AG</p>
        <p>Inventar Management System v1.0</p>
      </div>
    </footer>
  );
};

export default LoginFooter;
